// extracted by mini-css-extract-plugin
export default {"block":"B8oN6_9gESdNwSCabGVg","blockHeader":"gIA9UZ8IcG3ykv0gHgw4","blockBody":"DVbpCUilHnUEdi7TI2iR","blockBodyRow":"mcJXeXEN5XmU2hStU5gS","blockBodyRowItem":"YV5YpEvVhGGqmKYEwhW9"};